import React, { useState, useEffect } from 'react';
import { Col, Row } from 'react-bootstrap';
import { COLOR_BUTTON } from '../../Config/Config';
import { Button, Text, Img, Checkbox } from '../../Atoms';
import { Upload, Input } from '../../Molecules';
import { OrganismSelectContact } from '../index';
import fileImage from '../../assets/img/file.png';

/*
Situation de l'enfant → Type de document requis
*/

const typeDocumentMaintienEnfantOptions = [
  {
    id: 0,
    value: {
      docToSend: 'Avis imposition + certificat scolarité',
      idDocToSend: 0,
      situation: 'En étude'
    },
    text: 'En étude'
  },
  {
    id: 1,
    value: {
      docToSend: 'Contrat de travail',
      idDocToSend: 6,
      situation: 'Apprenti/Alternance'
    },
    text: 'Apprenti/Alternance'
  },
  {
    id: 2,
    value: {
      docToSend: 'Avis d\'imposition + Notification de rejet d’indemnisation de Pôle Emploi',
      idDocToSend: 1,
      situation: 'Primo demandeur d\'emploi'
    },
    text: 'Primo demandeur d\'emploi'
  },
  {
    id: 3,
    value: {
      docToSend: 'Carte d\'invalidité ou notification MDPH',
      idDocToSend: 2,
      situation: 'Enfant handicapé'
    },
    text: 'Enfant handicapé'
  },
  {
    id: 4,
    value: {
      docToSend: 'Avis d\'imposition',
      idDocToSend: 3,
      situation: 'Enfant fiscalement à charge'
    },
    text: 'Enfant fiscalement à charge'
  },
  {
    id: 5,
    value: {
      docToSend: 'Carte de volontaire',
      idDocToSend: 4,
      situation: 'Service civique'
    },
    text: 'Service civique'
  },
  {
    id: 6,
    value: {
      docToSend: 'Autres',
      idDocToSend: 5,
      situation: 'Autres'
    },
    text: 'Autres'
  }
];


const getCurrentSchoolYearOptions = () => {
  const currentYear = new Date().getFullYear();
  return [
    { id:0,value: `${currentYear - 1}`, text: `${currentYear - 1}/${currentYear}` },
    { id:1,value: `${currentYear}`, text: `${currentYear}/${currentYear + 1}` },
    // { value: `${currentYear + 1}`, text: `${currentYear + 1}/${currentYear + 2}` },
  ];
};
const getCurrentSchoolYear = () => {
  const currentDate = new Date();

  // Fonction pour déterminer l'année scolaire en cours
  const getSchoolYear = (date) => {
    // Si le mois est septembre (8 en JavaScript) ou plus tard, c'est la nouvelle année scolaire
    // Sinon, c'est l'année scolaire qui a commencé l'année précédente
    return date.getMonth() >= 8 ? date.getFullYear() : date.getFullYear() - 1;
  };

  const schoolYear = getSchoolYear(currentDate);

  // Retourne un seul objet représentant l'année scolaire actuelle
  return [{
    id:0,
    value: `${schoolYear}`,
    text: `${schoolYear}/${schoolYear + 1}`
  }];
};

const MaintienEnfantStep1 = ({
                               benefItems,
                               onChangeSelect,
                               onChange,
                               selectFile,
                               files,
                               onSubmit,
                               description,
                               textInfoBenef
                             }) => {
  const [selectedDocType, setSelectedDocType] = useState('-');
  const schoolYearOptions = getCurrentSchoolYear();
  const [isMaintainChildSupportAgreement, setMaintainChildSupportAgreement] = useState(false);
  const [isBeneficiaireSet, setIsBeneficiaireSet] = useState(false);
  const [isSchoolYearSet, setIsSchoolYearSet] = useState(false);
  const [isSituationSet, setIsSituationSet] = useState(false);

  const [isNbFile, setIsNbFile] = useState(0);
// Initialisation de l'état pour stocker les valeurs sélectionnées
  const [selectedValues, setSelectedValues] = useState({
    benefitaire: null,  // Stocke la valeur sélectionnée pour le bénéficiaire
    schoolYear: null,   // Stocke l'année scolaire sélectionnée
    situation: null,       // Stocke la situation sélectionné
    typedoc: null,       // Stocke le type de document sélectionné
  });

  /*
  met à jour le champ select
   */

  const handleSelectChange = (text, field, options) => {
    const selectedOption = findOptionByText(text, options);

    if (selectedOption) {
      const { value, text } = selectedOption;
      onChangeSelect({ target: { value, text } }, field);

      setSelectedValues(prevValues => ({
        ...prevValues,
        [field]: value
      }));

    }
  };

  const updateIsNbFile = (situation, files) => {
    if (situation && situation.idDocToSend === 0) { // "En étude"
      setIsNbFile(files.length > 1);
    } else {
      setIsNbFile(files.length > 0);
    }
  };

  useEffect(() => {
    setIsBeneficiaireSet(!!selectedValues.benefitaire);
    setIsSchoolYearSet(!!selectedValues.schoolYear);
    setIsSituationSet(!!selectedValues.situation);
    setSelectedDocType(!!selectedValues.typedoc);
    if (selectedValues.situation) {
      setIsSituationSet(true);
      setSelectedDocType(selectedValues.situation.docToSend);
      updateIsNbFile(selectedValues.situation, files);
    } else {
      setIsSituationSet(false);
      setSelectedDocType(false);
    }
  }, [selectedValues, files]);

  // Fonction pour vérifier si tous les champs requis sont renseignés
  const areAllFieldsSet = () => {
    return isBeneficiaireSet && isSchoolYearSet && isSituationSet && isNbFile;
  };




  const generateDocToSendOptions = () => {
    return typeDocumentMaintienEnfantOptions.map(option => ({
      id: option.id,
      value: option.value,
      text: option.value.docToSend
    }));
  };

  // Fonction utilitaire pour trouver l'option correspondante
  const findOptionByText = (text, options) => {
    const option = options.find(opt => opt.text === text);
    if (option) {
      return {
        text: option.text,
        value: option.value
      };
    }
    return null;
  };


  const toggleAgreement = (event) => {
   setMaintainChildSupportAgreement(!event.target.checked);
  };

  return (
    <div>
      <Row className="row-document">
        <Col xs={6} className="col-document">
          <Text text="Bénéficiaire" className="label-input-document" />
          <OrganismSelectContact
            containerClassName="select-document-container"
            placeholder=""
            iconClassName="icon-select-document"
            onChange={(value) => handleSelectChange(value, 'benefitaire', benefItems)}

            containerMobileOption="container-option-mobile-document"
            subTitleMobileClassName="sub-title-select-document"
            headerClassName="header-select-document"
            options={benefItems}
            iconSize={'7px'}
          />
        </Col>
        <Col xs={6} className="col-document">
          <Text text="Année scolaire" className="label-input-document" />
          <OrganismSelectContact
            containerClassName="select-document-container"
            placeholder=""
            iconClassName="icon-select-document"
            onChange={(value) => handleSelectChange(value, 'schoolYear', schoolYearOptions)}

            containerMobileOption="container-option-mobile-document"
            titleMobile="Année scolaire"
            subTitleMobileClassName="sub-title-select-document"
            subTitleMobile=""
            header="Sélectionnez l'année scolaire"
            headerClassName="header-select-document"
            options={schoolYearOptions}
            iconSize={'7px'}
          />
        </Col>

        {textInfoBenef && (

        <Col xs={12} lg={12} className="col-document">
          <Text text={textInfoBenef}  className={'doc-red-text'} type="H6"/>
          </Col>

          )
        }

        <Col xs={6} lg={12} className="col-document">
          <Text text="Situation de votre enfant" className="label-input-document" />
          <OrganismSelectContact
            containerClassName="select-document-container"
            placeholder=""
            iconClassName="icon-select-document"
            onChange={(value) => handleSelectChange(value, 'situation',typeDocumentMaintienEnfantOptions)}

            containerMobileOption="container-option-mobile-document"
            titleMobile="Situation de votre enfant"
            subTitleMobileClassName="sub-title-select-document"
            subTitleMobile=""
            header="Situation de votre enfant"
            headerClassName="header-select-document"
            options={typeDocumentMaintienEnfantOptions}
            iconSize={'7px'}
          />
        </Col>
        <Col xs={6} lg={12} className="col-document">
          <Text text="Type de document : " className="label-input-document" />
          <OrganismSelectContact
            containerClassName="select-document-container"
            placeholder=""
            iconClassName="icon-select-document"
            onChange={(value) => handleSelectChange(value, 'typedoc',generateDocToSendOptions())}
            containerMobileOption="container-option-mobile-document"
            titleMobile="Document requis"
            subTitleMobileClassName="sub-title-select-document"
            subTitleMobile=""
            header="Document requis"
            headerClassName="header-select-document"
            value={selectedDocType}
            options={generateDocToSendOptions()}
            iconSize={'7px'}
          />
        </Col>

        <Col xs={6} lg={12} className="col-document">
          <div className="container-spaced">
            <Checkbox
              type="checkbox"
              size={14}
              checked={isMaintainChildSupportAgreement}
              onClick={(value) =>toggleAgreement(value,'agreement')}
            />
            <div className="m-3">
              <Text text="Je certifie sur l'honneur l'exactitude des renseignements portés sur cette déclaration" type="h6"/>
            </div>
          </div>
        </Col>
      </Row>



          <Upload
            handleFileChange={selectFile}
            id="document"
            contentClassName={'input-file-document'}
            style={{ height: '1px' }}
            uploadContent={
              <div className="content-input-file-document">
                <Img src={fileImage} className="img-file-upload" />
                <div>
                  Glissez et déposez vos fichiers ici, ou{' '}
                  <span>téléchargez-les</span> depuis votre ordinateur
                </div>
              </div>
            }
          />

      <Input
        className="input-decription-document input-description-medicine"
        onChange={(e) => onChange(e)}
        value={description}
        as="textarea"
        placeholder="Laissez-nous un message qui décrit votre besoin (facultatif)"
      />




      {isMaintainChildSupportAgreement && areAllFieldsSet() ? (
        <div>
          {/* si case cochée */}
          {/* et si benef + année + sitation */}
          {/* et si situation et nb doc >1*/}
          <div className="container-btn-send-doc">
            <Button
              text="Envoyer"
              className="btn-send-doc btn-send-doc-medicine"
              onClick={() => onSubmit()}
              resetHover={true}
            />
          </div>
        </div>

      ) : (

        <div>
          {/*Vous devez cocher la case*/}
          <div className="container-btn-send-doc">
            <Button
              text="Envoyer"
              className="btn-send-doc btn-send-doc-medicine"
              disabled={true}
              resetHover={true}
            />
        </div>
        </div>
        )}



    </div>
  );
};

export default MaintienEnfantStep1;